module.exports = __webpack_public_path__ + "static/media/oveja.12beca72.png";